
import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * common button
 *
 * You probably want ButtonPrimary or ButtonSecondary.
 */
@Component
export default class Button extends Vue {
	@Prop({type: Boolean, default: false})
	expand!: boolean;

	/**
	 * QBtn size prop
	 *
	 * allows individual instances to override default size
	 */
	@Prop({default: 'lg'})
	size!: string;
}
